'use strict';

jQuery(function ($) {
	$(window).on('load', function () {
		$('.navigation-bar').each(function () {
			var thisNavBar = $(this);
			var aTop = thisNavBar.offset().top;
			var thisNavBarInner = $('.nav-bar-inner', thisNavBar);

			if (thisNavBar.hasClass("sticky")) {
				$(window).on('scroll', function (e) {
					if ($(this).scrollTop() >= aTop) {
						var navBarHeight = thisNavBarInner.outerHeight();
						thisNavBar.css('height', navBarHeight + 'px');
						thisNavBarInner.addClass('fixed');
					} else {
						thisNavBar.css('height', 'auto');
						thisNavBarInner.removeClass('fixed');
					}
				});
			}

			$('.mobile-header', thisNavBar).on('click', function (e) {
				e.preventDefault();
				thisNavBar.toggleClass('open');
			})
		});
	});
});